// extracted by mini-css-extract-plugin
export default {"slidesContainer":"FocusedBlock_slidesContainer__N0jOB"};